import * as types from '../constants/action-types';
import { Profile } from '../../../../api/api-profile';
import { Session } from '../../../../api/api-user';

import { fetchMessageCount, fetchManagedAccount, fetchBankStatus } from './nav';
import { fetchUserNux } from './nux';
import { fetchEntitlements } from './entitlements';


function resetAuth () {
  return {
    type: types.RESET_ENV
  };
}

function receiveAccessToken (accessToken) {
  return {
    type: types.RECEIVE_ACCESS_TOKEN,
    accessToken
  };
}

function accessTokenFailure () {
  return {
    type: types.ACCESS_TOKEN_FAILURE
  };
}

function receiveGAClientId (gaClientId) {
  return {
    type: types.RECEIVE_GA_CLIENT_ID,
    gaClientId
  };
}

function profileRequest () {
  return {
    type: types.PROFILE_REQUEST
  };
}

function profileSuccess (profile) {
  PSSessions.Cookies.set('PSUser', profile.SSOid);
  return {
    type: types.PROFILE_SUCCESS,
    profile
  };
}

function profileFailure () {
  return {
    type: types.PROFILE_FAILURE
  };
}

function preProfileSuccess (accessToken, profile) {
  return dispatch => {
    const gaClientId = analyticsIntegrations.getGoogleAnalyticsID();

    // Profile has been received, dispatch various
    // actions around other `auth` level state.
    dispatch(profileSuccess(profile));
    dispatch(receiveGAClientId(gaClientId));
    dispatch(fetchMessageCount(accessToken, profile));
    dispatch(fetchManagedAccount(accessToken, profile));
    dispatch(fetchEntitlements(accessToken, profile));
    dispatch(fetchUserNux('trigger=page-load'));
    if (profile.is_host && profile.sk_completed) {
      dispatch(fetchBankStatus(accessToken, profile));
    }
  };
}

function fetchProfile (accessToken) {
  return dispatch => {
    const profilePath = '/v1/profiles/me';

    // Dispatch action that profile is being requested.
    dispatch(profileRequest());

    // Request profile.
    Profile.read(profilePath, accessToken, (response) => {
      // No profile.
      if (response.error) {
        return dispatch(profileFailure());
      }

      // Successful profile.
      return dispatch(preProfileSuccess(accessToken, response));
    });
  };
}

export function createProfile (profileObj, query) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      // Dispatch action that profile is being requested.
      dispatch({ type: types.PROFILE_CREATE_REQUEST });

      // Create profile
      Profile.create(profileObj, (response) => {
        if (response.error) {
          dispatch({ type: types.PROFILE_CREATE_FAILURE });
          return reject(response);
        }
        // Successful profile.
        dispatch({ type: types.PROFILE_CREATE_SUCCESS });
        return resolve(response);
      }, query);
    });
  };
}

export function updateProfile (profileObj) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { auth } = getState();
      // Dispatch action that profile is being requested.
      dispatch({ type: types.PROFILE_UPDATE_REQUEST });

      // Request profile.
      Profile.update('me', auth.accessToken, profileObj, (response) => {
        // No profile.
        if (response.error) {
          return reject(dispatch({
            type: types.PROFILE_UPDATE_FAILURE,
            error: response.error
          }));
        }
        // Successful profile.
        return resolve(dispatch({
          type: types.PROFILE_UPDATE_SUCCESS,
          profile: response.profile
        }));
      });
    });
  };
}

export function updateProfile200 (profile) {
  return (dispatch) => {
    return dispatch({
      type: types.PROFILE_UPDATE_SUCCESS,
      profile
    });
  };
}

export function logoutUser () {
  return (dispatch, getState) => {
    const { auth } = getState();
    const { accessToken } = auth;

    Session.destroy(accessToken, (response) => {
      const { error } = response;
      if (error && (-1 === error.indexOf('Invalid Access Token'))) {
        // TODO: Handle this gracefully
        // eslint-disable-next-line no-console
        console.log(`couldn't log out because ${response.error}`);
      } else {
        PSSessions.eH.logout();
        analyticsIntegrations.accountLogout();

        dispatch(resetAuth());
      }
    });
  };
}

/**
 * Main `auth` level action dispatcher
 * (accessToken, profile, gaclientid)
 *
 * @function
 * @name initAuth
 */
export function initAuth (accessToken) {
  return (dispatch, getState) => {
    return new Promise((resolve) => {
      const { auth } = getState();
      const token = auth.accessToken || accessToken;

      if (!token) {
        // Not all pages require authentication,
        // so we simply dispatch this action to track the state.
        // See router for authenicated routes.
        return dispatch(accessTokenFailure());
      }

      dispatch(receiveAccessToken(token));
      dispatch(fetchProfile(token));
      return resolve(token);
    });
  };
}
